module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__officeBanking_White.cc781736.svg";